import React, { useState } from 'react';
import { C, inputStyle, labelStyle } from './constants';
export function FLabel({
  children
}: {
  children: ReactNode;
}) {
  return <label style={labelStyle} data-id="element-346">{children}</label>;
}
export function FInput({
  value,
  onChange,
  type = 'text',
  placeholder = ''
}: {
  value: string;
  onChange: (val: string) => void;
  type?: string;
  placeholder?: string;
}) {
  const [focused, setFocused] = useState(false);
  return <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={{
    ...inputStyle,
    borderColor: focused ? C.crimsonMid : C.parchmentDark,
    background: focused ? '#fff' : C.parchment,
    boxShadow: focused ? `0 0 0 3px rgba(178,34,34,0.10)` : 'none'
  }} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} data-id="element-347" />;
}
export function FTextarea({
  value,
  onChange,
  rows = 4,
  placeholder = ''
}: {
  value: string;
  onChange: (val: string) => void;
  rows?: number;
  placeholder?: string;
}) {
  const [focused, setFocused] = useState(false);
  return <textarea value={value} onChange={e => onChange(e.target.value)} rows={rows} placeholder={placeholder} style={{
    ...inputStyle,
    resize: 'vertical',
    minHeight: rows * 24,
    borderColor: focused ? C.crimsonMid : C.parchmentDark,
    background: focused ? '#fff' : C.parchment,
    boxShadow: focused ? `0 0 0 3px rgba(178,34,34,0.10)` : 'none'
  }} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} data-id="element-348" />;
}
export function FSelect({
  value,
  onChange,
  children
}: {
  value: string;
  onChange: (val: string) => void;
  children: ReactNode;
}) {
  const [focused, setFocused] = useState(false);
  return <div style={{
    position: 'relative'
  }} data-id="element-349">
      <select value={value} onChange={e => onChange(e.target.value)} style={{
      ...inputStyle,
      appearance: 'none',
      paddingRight: 34,
      cursor: 'pointer',
      borderColor: focused ? C.crimsonMid : C.parchmentDark,
      background: focused ? '#fff' : C.parchment,
      boxShadow: focused ? `0 0 0 3px rgba(178,34,34,0.10)` : 'none'
    }} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} data-id="element-350">
        {children}
      </select>
      <svg viewBox="0 0 12 12" style={{
      position: 'absolute',
      right: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 10,
      height: 10,
      pointerEvents: 'none',
      color: C.crimson
    }} fill={C.crimson} data-id="element-351">
        <path d="M6 8L1 3h10z" data-id="element-352" />
      </svg>
    </div>;
}
export function CheckItem({
  checked,
  onChange,
  label
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}) {
  return <label style={{
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 13,
    color: C.inkMid,
    cursor: 'pointer'
  }} data-id="element-353">
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} style={{
      width: 16,
      height: 16,
      accentColor: C.crimsonMid,
      cursor: 'pointer',
      flexShrink: 0
    }} data-id="element-354" />
      {label}
    </label>;
}
export function CheckBox({
  title,
  children
}: {
  title?: string;
  children: ReactNode;
}) {
  return <div style={{
    background: C.goldPale,
    border: `1px solid ${C.goldBorder}`,
    borderRadius: 8,
    padding: 16
  }} data-id="element-355">
      {title && <div style={{
      fontSize: 13,
      fontWeight: 700,
      color: C.crimson,
      fontFamily: 'Georgia,serif',
      marginBottom: 12
    }} data-id="element-356">
          {title}
        </div>}
      {children}
    </div>;
}
export function Grid({
  cols = 2,
  children
}: {
  cols?: number;
  children: ReactNode;
}) {
  return <div style={{
    display: 'grid',
    gridTemplateColumns: `repeat(${cols},1fr)`,
    gap: 16
  }} data-id="element-357">
      {children}
    </div>;
}
export function FormGroup({
  label,
  children,
  span
}: {
  label?: string;
  children: ReactNode;
  span?: number;
}) {
  return <div style={{
    gridColumn: span ? `span ${span}` : undefined,
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  }} data-id="element-358">
      {label && <FLabel data-id="element-359">{label}</FLabel>}
      {children}
    </div>;
}
export function Divider() {
  return <hr style={{
    border: 'none',
    borderTop: `1px solid ${C.parchmentDark}`,
    margin: '16px 0'
  }} data-id="element-360" />;
}